import { useAuthStore } from '@/stores/auth'
import LiveCaller from '@/LiveCaller'
import { useWebSocketStore } from '@/stores/websocket'
import BaseMiddleware from './BaseMiddleware'

export default class Auth extends BaseMiddleware {
    handle(request, next) {
        useAuthStore().load(false).then(() => {
            next(request)
        }).catch((e) => {
            try {
                if (e.response.status === 401) {
                    // Cleanup WebSocket before redirect
                    try {
                        const websocketStore = useWebSocketStore()
                        websocketStore.destroy()
                    } catch (err) {
                        // Ignore if store not initialized
                    }
                    // Clear invalid token using $storage (automatically clears localStorage)
                    if (LiveCaller.app?.$storage) {
                        LiveCaller.app.$storage.remove('oauth')
                    }
                    request.router.next('/signin').catch(() => {})
                }
            } catch (err) {
                LiveCaller.app.$_error('Error401')
            }
        })
    }
}
